import { APP } from "./actions"

const initState = {
  loading: false,
  showNotification: false,
  showConfirmation: false,
  message: "",
  appId: "",
}

const reducer = (state = initState, action) => {
  let stateClone = { ...state }
  const { type, payload } = action

  switch (type) {
    case APP.loading:
      stateClone.loading = payload
      break
    case APP.notification.show:
      stateClone.showNotification = true
      stateClone.message = payload
      break
    case APP.notification.hide:
      stateClone = initState
      stateClone.showNotification = false
      break
    case APP.confirmation.show:
      stateClone.showConfirmation = true
      stateClone.message = payload
      break
    case APP.confirmation.hide:
      stateClone = initState
      stateClone.showConfirmation = false
      break
    case APP.appId:
      stateClone.appId = payload
      break
    default:
      stateClone = initState
      break
  }

  return stateClone
}

export default reducer
